import { DireccionPersona, DireccionPersonaRequest } from '../../model/persona/direccion-persona';

/**
 * Puerto Abstracto: DireccionPersonaRepository
 * 
 * Define el contrato que deben implementar los adaptadores de infraestructura.
 * Trabaja con la entidad de dominio DireccionPersona.
 * 
 * Arquitectura Hexagonal:
 * - Este puerto está en el dominio
 * - HttpDireccionPersonaRepository (adaptador) lo implementa en infraestructura
 * 
 * @author Emerson Rodriguez - Ingeneo
 */
export abstract class DireccionPersonaRepository {
  
  /**
   * Obtiene todas las direcciones de una persona
   */
  abstract getByPersona(cdpersona: number): Promise<DireccionPersona[]>;
  
  /**
   * Obtiene solo direcciones activas de una persona
   */
  abstract getActivasByPersona(cdpersona: number): Promise<DireccionPersona[]>;
  
  /**
   * Obtiene una dirección por ID
   */
  abstract getById(cdpersona: number, nmconsecutivo: number): Promise<DireccionPersona>;
  
  /**
   * Crea una nueva dirección
   */
  abstract create(cdpersona: number, direccion: DireccionPersonaRequest): Promise<DireccionPersona>;
  
  /**
   * Actualiza una dirección existente
   */
  abstract update(cdpersona: number, nmconsecutivo: number, direccion: DireccionPersonaRequest): Promise<DireccionPersona>;
  
  /**
   * Inactiva una dirección (soft delete)
   */
  abstract delete(cdpersona: number, nmconsecutivo: number): Promise<void>;
  
  /**
   * Cuenta direcciones activas de una persona
   */
  abstract countActivas(cdpersona: number): Promise<number>;
}
